import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './Contact.css';
import * as icons from '../icons/Icons';

const contact = [
  {
    href: 'mailto:jaylanovanderveen.work@gmail.com',
    label: 'Email',
    value: 'jaylanovanderveen.work@gmail.com',
    icon: icons.email
  },
  {
    href: 'tel:+310622074762',
    label: 'Phone',
    value: '+31 06 22074762',
    icon: icons.phone
  },
  {
    label: 'Location',
    value: 'Netherlands',
    icon: icons.location
  },
];

const socials = [
  // {
  //   href: 'https://github.com/Jaylano',
  //   label: 'GitHub',
  //   value: '@Jaylano',
  //   icon: icons.github
  // },
  {
    href: 'https://discordapp.com/users/467655117248659456',
    label: 'Discord',
    value: 'simple_dimple',
    icon: icons.discord
  },
  {
    href: 'https://instagram.com/Jaylanooooo',
    label: 'Instagram',
    value: '@jaylanooooo',
    icon: icons.instagram
  },
  {
    href: 'https://tiktok.com/@jaylanooooo',
    label: 'TikTok',
    value: '@jaylanooooo',
    icon: icons.tiktok
  },
];

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState('idle');

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  return (
    <motion.div
      className="contact-page"
      initial={{ opacity: 0, y: 14 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -14 }}
      transition={{ duration: 0.25 }}
    >
      <div className="contact-header">
        <div className="contact-header-glow" />
        <div className="container">
          <h1 className="contact-title">
            Contact <span className="accent">Me</span>
          </h1>
          <p className="contact-intro">
            Interest in working together or something else? Feel free to reach out through any of the channels below or send me a message using the contact form!
          </p>
        </div>
      </div>

      <div className="contact-body">
        <div className="container contact-grid">

          <div className="contact-left">
            <section className="info-section">
              <span className="section-tag">Personal</span>
              <div className="info-list">
                {contact.map(({ href, label, value, icon }) =>
                  href ? (
                    <a key={label} href={href} className="info-row">
                      <img src={icon} className="contact-icon" />
                      <div className="info-text">
                        <span className="info-label">{label}</span>
                        <span className="info-val">{value}</span>
                      </div>
                    </a>
                  ) : (
                    <div key={label} className="info-row static">
                      <img src={icon} alt={label} className="contact-icon" />
                      <div className="info-text">
                        <span className="info-label">{label}</span>
                        <span className="info-val">{value}</span>
                      </div>
                    </div>
                  )
                )}
              </div>
            </section>

            <div className="info-sep" />
            <section className="info-section">
              <span className="section-tag">Socials</span>
              <div className="info-list">
                {socials.map(({ href, label, value, icon }) => (
                  <a key={label} href={href} target="_blank" rel="noreferrer" className="info-row social">
                    <img src={icon} alt={label} className="contact-icon" />
                    <div className="info-text">
                      <span className="info-label">{label}</span>
                      <span className="info-val">{value}</span>
                    </div>
                  </a>
                ))}
              </div>
            </section>
          </div>

          <div className="contact-right">
            <div className="form-card">
              <div className="form-card-glow" />
              <h2 className="form-heading">Send me a message (Temporary Disabled)</h2>

              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">Name</label>
                  <input
                    type="text"
                    name="name"
                    className="form-input"
                    value={form.name}
                    onChange={handleChange}
                    placeholder="Your name"
                    required
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    name="email"
                    className="form-input"
                    value={form.email}
                    onChange={handleChange}
                    placeholder="your@email.com"
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="form-label">Message</label>
                <textarea
                  name="message"
                  className="form-input form-textarea"
                  value={form.message}
                  onChange={handleChange}
                  placeholder="Tell me about your project or ask a question..."
                  required
                  rows={5}
                />
              </div>

              <button type="submit" className="btn-send">
                Send Message
              </button>
            </div>
          </div>
        </div>
      </div>

    </motion.div>
  );
}
